module.exports = __webpack_public_path__ + "media/images/athletes/2470-b86a06da186665ff50f75a42efbefe5d.png";